<div class="menu-icon">
    <div class="row">
        <div class="col-auto">
            <app-logo [size]="'30px'"></app-logo>
            <app-logo-project [size]="'30px'" class="ml-4"></app-logo-project>
        </div>
    </div>
</div>

<div class="menu-list">
    <div [routerLinkActiveOptions]="{ exact: true }"
         [routerLink]="['/main']"
         class="menu-list-item" routerLinkActive="active">
        <i class="icon-squares"></i>
        <span>{{'LOGIN.APP_NAME' | translate}}</span>
    </div>

    <div [routerLinkActiveOptions]="{ exact: true }"
         [routerLink]="['/new-offer']"
         *ngIf="!readonly"
         class="menu-list-item" routerLinkActive="active">
        <i class="icon-squares"></i>
        <span>{{'OFFER_CONFIG.NEW_OFFER' | translate}}</span>
    </div>

    <div [routerLinkActiveOptions]="{ exact: true }"
         [routerLink]="['/new-frontier']"
         *ngIf="user?.frontierAccess"
         class="menu-list-item" routerLinkActive="active">
        <i class="icon-squares"></i>
        <span>{{'DASHBOARD.NEW_FRONTIER_SUB' | translate}}</span>
    </div>

    <div [routerLink]="['/registry']"
         class="menu-list-item" routerLinkActive="active">
        <i class="icon-squares"></i>
        <span>{{'REGISTRY.LIST' | translate}}</span>
    </div>

    <div [routerLinkActiveOptions]="{ exact: true }"
         [routerLink]="['/timetable']"
         *ngIf="user?.timetableAccess"
         class="menu-list-item" routerLinkActive="active">
        <i class="icon-squares"></i>
        <span>{{'TIMETABLE.TITLE' | translate}}</span>
    </div>

</div>
